import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ZapIcon, DownloadIcon, InfinityIcon, CheckCircle2 } from 'lucide-react';
export const PricingSection = memo(function PricingSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48181622702250:1';
  return <section id="compra" className="py-14 px-4 bg-gray-50 scroll-mt-20 border-t border-gray-200 relative overflow-hidden" data-id="element-89">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-90" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-91">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-92">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 leading-tight mb-3" data-id="element-93">
            Cada día que esperás es{' '}
            <span className="text-red-500" data-id="element-94">tiempo que no vuelve.</span>
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed font-medium" data-id="element-95">
            Proyectos muertos, mañanas quemadas, potencial sin materializar.{' '}
            <span className="text-gray-900 font-bold" data-id="element-96">
              El Megapack Domina Tu Mente es la salida.
            </span>
          </p>
        </div>

        {/* Card */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl border border-gray-200 shadow-lg overflow-hidden" data-id="element-97">
          {/* Banner urgencia */}
          <div className="bg-red-600 text-white text-center py-2 text-[11px] font-black uppercase tracking-widest animate-pulse" data-id="element-98">
            🔥 OFERTA SOLO POR HOY — DESPUÉS SUBE DE PRECIO 🔥
          </div>

          <div className="p-5 md:p-8" data-id="element-99">
            {/* Items incluidos */}
            <div className="space-y-2 mb-4" data-id="element-100">
              {[{
              icon: '📚',
              name: '6 Tomos PDF — De Coma Digital a Ejecutor',
              value: '$53.400'
            }, {
              icon: '🎁',
              name: '4 Bonos Exclusivos de Activación',
              value: '$30.600'
            }, {
              icon: '♾️',
              name: 'Acceso inmediato y de por vida',
              value: ''
            }].map((item, i) => <div key={i} className="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-3 border border-gray-200" data-id="element-101">
                  <div className="flex items-center gap-2.5" data-id="element-102">
                    <CheckCircle2 className="w-4 h-4 text-yellow-500 flex-shrink-0" data-id="element-103" />
                    <span className="text-gray-700 text-sm font-medium" data-id="element-104">
                      <span className="mr-1.5" data-id="element-105">{item.icon}</span>
                      {item.name}
                    </span>
                  </div>
                  {item.value && <span className="text-gray-400 line-through text-xs font-medium flex-shrink-0 ml-3" data-id="element-106">
                      {item.value}
                    </span>}
                </div>)}
            </div>

            {/* Total tachado */}
            <div className="flex justify-between items-center bg-gray-100 px-4 py-3 rounded-lg border border-gray-200 mb-5" data-id="element-107">
              <span className="text-gray-500 font-bold text-xs uppercase tracking-wider" data-id="element-108">
                Valor Real
              </span>
              <span className="text-red-500 font-black text-base line-through" data-id="element-109">
                $83.900 ARS
              </span>
            </div>

            {/* Precio */}
            <div className="text-center mb-5 relative" data-id="element-110">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-yellow-500/10 rounded-full blur-2xl pointer-events-none" data-id="element-111" />
              <p className="text-yellow-500 text-[11px] font-black uppercase tracking-widest mb-2 relative z-10" data-id="element-112">
                SOLO POR HOY PAGÁS:
              </p>
              <div className="flex items-start justify-center gap-1 relative z-10" data-id="element-113">
                <span className="text-gray-500 text-lg font-bold mt-2" data-id="element-114">$</span>
                <p className="text-6xl md:text-7xl font-black text-gray-900 tracking-tighter leading-none" data-id="element-115">
                  19.990
                </p>
              </div>
              <div className="flex items-center justify-center gap-3 mt-2 relative z-10" data-id="element-116">
                <span className="text-gray-500 text-xs font-bold" data-id="element-117">ARS</span>
                <span className="bg-green-100 text-green-700 px-2.5 py-0.5 rounded-full text-[11px] font-black border border-green-200" data-id="element-118">
                  AHORRÁS +80%
                </span>
              </div>
            </div>

            {/* Alerts compactos */}
            <div className="flex flex-col md:flex-row gap-2 mb-5" data-id="element-119">
              <div className="flex-1 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2.5 flex items-center gap-2" data-id="element-120">
                <span data-id="element-121">💰</span>
                <p className="text-yellow-700 text-[12px] font-bold" data-id="element-122">
                  Lo recuperás con las primeras 4 horas de foco que ganás.
                </p>
              </div>
              <div className="flex-1 bg-red-50 border border-red-200 rounded-lg px-3 py-2.5 flex items-center gap-2" data-id="element-123">
                <span data-id="element-124">⏳</span>
                <p className="text-red-700 text-[12px] font-bold" data-id="element-125">
                  Cada día que esperás es un proyecto más que no va a existir.
                </p>
              </div>
            </div>

            {/* CTA */}
            <CTAButton href={CHECKOUT_URL} text="🧠 QUIERO DOMINAR MI MENTE" subtext="🔒 Pago seguro · Acceso inmediato · Garantía 30 días" data-id="element-126" />

            {/* Garantía */}
            <div className="flex items-center justify-center gap-2 mt-4 mb-4" data-id="element-127">
              <ShieldCheckIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-128" />
              <p className="text-gray-500 text-[11px] font-medium" data-id="element-129">
                Si en 30 días no te sirve, te devolvemos todo. Sin preguntas.
              </p>
            </div>

            {/* Trust signals */}
            <div className="grid grid-cols-4 gap-1 pt-4 border-t border-gray-200" data-id="element-130">
              {[{
              icon: ZapIcon,
              label: 'Inmediato',
              color: 'text-yellow-500'
            }, {
              icon: DownloadIcon,
              label: 'Digital',
              color: 'text-yellow-500'
            }, {
              icon: InfinityIcon,
              label: 'De por vida',
              color: 'text-yellow-500'
            }, {
              icon: ShieldCheckIcon,
              label: 'Garantía',
              color: 'text-green-600'
            }].map((item, i) => <div key={i} className="flex flex-col items-center gap-1.5 text-gray-500" data-id="element-131">
                  <item.icon className={`w-4 h-4 ${item.color}`} data-id="element-132" />
                  <span className="text-[9px] font-bold uppercase tracking-wider" data-id="element-133">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
});